//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { IInstagramHashtagConfig } from '@apis/instagram-hashtags-configuration/instagramHashtagsConfigApiModels';
import ITrackedHashtag from '@models/ITrackedHashtag';

export enum INSTAGRAM_HASHTAGS_ACTIONS {
    REQUEST_INSTAGRAM_HASHTAGS = 'INSTAGRAM_HASHTAGS_ACTIONS/REQUEST_INSTAGRAM_HASHTAGS',
    RECEIVE_INSTAGRAM_HASHTAGS_SUCCEEDED = 'INSTAGRAM_HASHTAGS_ACTIONS/RECEIVE_INSTAGRAM_HASHTAGS_SUCCEEDED',
    RECEIVE_INSTAGRAM_HASHTAGS_FAILED = 'INSTAGRAM_HASHTAGS_ACTIONS/RECEIVE_INSTAGRAM_HASHTAGS_FAILED',
    REQUEST_HASHTAGS_CONFIGS = 'INSTAGRAM_HASHTAGS_ACTIONS/REQUEST_HASHTAGS_CONFIGS',
    RECEIVE_HASHTAGS_CONFIGS_SUCCEEDED = 'INSTAGRAM_HASHTAGS_ACTIONS/RECEIVE_HASHTAGS_CONFIGS_SUCCEEDED',
    RECEIVE_HASHTAGS_CONFIGS_FAILED = 'INSTAGRAM_HASHTAGS_ACTIONS/RECEIVE_HASHTAGS_CONFIGS_FAILED',
}

export interface IInstagramHashtagsState {
  isFetchingTrackedHashtags: boolean;
  isFetchingHashtagConfigs: boolean;
  trackedHashtags: ITrackedHashtag[];
  hashtagConfigs: IInstagramHashtagConfig[];
}
